/* @flow */

const ativacaoItensMenu = (ativacao: string) => {
    const itensAba = document.querySelectorAll('#aba-ativa .nav-item');
    itensAba.forEach((item) => {
        const link = item.querySelector('a');
        if (link) {
            link.setAttribute('style', ativacao);
        }
    });
};

export default ativacaoItensMenu;
